class MobileMenu extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this._isB2B = document.body.classList.contains('tw-b2b');
    this._scrollContainer = this.closest('.header__inline-menu');
    this._onClick = this._handleClick.bind(this);
    this.addEventListener('click', this._onClick, { capture: true });

    this._bodyObserver = new MutationObserver(() => {
      if (!document.body.classList.contains('open_burger')) {
        this._resetAccordions();
        this._resetScroll();
      }
    });
    this._bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick, { capture: true });
    this._bodyObserver?.disconnect();
  }

  _resetAccordions() {
    this.querySelectorAll('[data-menu-category].is-expanded').forEach(item => {
      item.classList.remove('is-expanded');
      const trigger = item.querySelector(
        '.menu-drawer__menu-item.mobile-menu__toggle'
      );
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });

    this.querySelectorAll('.has-grandchild.active').forEach(item => {
      item.classList.remove('active');
      const trigger = item.querySelector('.has-grandchild-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  _resetScroll() {
    this._scrollContainer?.scrollTo({ top: 0, behavior: 'auto' });
  }

  _handleClick(event) {
    if (window.innerWidth > 1024) return;

    const level1Toggle = event.target.closest(
      '.menu-drawer__menu .menu-drawer__menu-item.mobile-menu__toggle'
    );
    if (level1Toggle && this.contains(level1Toggle)) {
      event.preventDefault();
      event.stopPropagation();
      this._toggleLevel1(level1Toggle);
      return;
    }

    const level2Toggle = event.target.closest(
      '.menu-drawer__menu .has-grandchild-link'
    );
    if (level2Toggle && this.contains(level2Toggle)) {
      event.preventDefault();
      event.stopPropagation();
      this._toggleLevel2(level2Toggle);
      return;
    }

    const level3Link = event.target.closest(
      '.menu-drawer__menu .has-grandchild.active .grandchild-link.child-wrap a'
    );
    if (level3Link && this.contains(level3Link)) {
      this._pushNavEvent(
        level3Link,
        'menu_header_3_click',
        this._getQaValue(level3Link)
      );
      return;
    }

    const level2Link = event.target.closest(
      '.menu-drawer__menu .mobile-item__child .child-link:not(.has-grandchild-link)'
    );
    if (level2Link && this.contains(level2Link)) {
      this._pushNavEvent(
        level2Link,
        'menu_header_2_click',
        this._getQaValue(level2Link)
      );
      return;
    }

    const level1Link = event.target.closest(
      '.menu-drawer__menu .menu-drawer__menu-item:not(.mobile-menu__toggle)'
    );
    if (level1Link && this.contains(level1Link)) {
      this._pushLevel1LinkEvent(level1Link);
    }
  }

  _toggleLevel1(toggle) {
    const category = toggle.closest('[data-menu-category]');
    if (!category) return;

    const isExpanded = category.classList.contains('is-expanded');
    const from = this._getQaValue(toggle);

    this.querySelectorAll('[data-menu-category].is-expanded').forEach(item => {
      if (item === category) return;
      item.classList.remove('is-expanded');
      const trigger = item.querySelector(
        '.menu-drawer__menu-item.mobile-menu__toggle'
      );
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      this._collapseChildItems(item);
    });

    category.classList.toggle('is-expanded', !isExpanded);
    toggle.setAttribute('aria-expanded', String(!isExpanded));

    if (!isExpanded) {
      this._collapseChildItems(category);
      this._scrollItemIntoView(toggle);
      this._pushLevel1LinkEvent(toggle, from);
      return;
    }

    this._pushReturnEvent(from);
  }

  _toggleLevel2(toggle) {
    const parent = toggle.closest('.has-grandchild');
    if (!parent) return;

    const childList = parent.closest('.mobile-item__child');
    const isActive = parent.classList.contains('active');
    const from = this._getQaValue(toggle);

    childList?.querySelectorAll('.has-grandchild.active').forEach(item => {
      if (item === parent) return;
      item.classList.remove('active');
      const trigger = item.querySelector('.has-grandchild-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });

    parent.classList.toggle('active', !isActive);
    toggle.setAttribute('aria-expanded', String(!isActive));

    if (!isActive) {
      this._scrollItemIntoView(toggle);
    }

    this._pushNavEvent(
      toggle,
      isActive ? 'menu_header_2_dropdown_close' : 'menu_header_2_dropdown_open',
      from
    );
  }

  _collapseChildItems(category) {
    category.querySelectorAll('.has-grandchild.active').forEach(child => {
      child.classList.remove('active');
      const trigger = child.querySelector('.has-grandchild-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  _scrollItemIntoView(item) {
    requestAnimationFrame(() => {
      item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  _pushLevel1LinkEvent(item, from = this._getQaValue(item)) {
    if (this._isB2B) {
      this._pushDataLayer('header_section_redirect_click', {
        from: 'mobile',
        content_url: from
      });
      return;
    }

    this._pushNavEvent(item, 'menu_header_1_click', from);
  }

  _pushReturnEvent(from) {
    this._pushDataLayer('menu_return_click', { from });
  }

  _pushNavEvent(item, eventName, from) {
    const parameters = { type: 'mobile' };

    if (item.classList.contains('wrap-item')) {
      parameters.to = from;
    } else {
      parameters.from = from;
    }

    this._pushDataLayer(eventName, parameters);
  }

  _pushDataLayer(eventName, parameters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_event',
      event_name: eventName,
      parameter: JSON.stringify(parameters)
    });
  }

  _getQaValue(el) {
    const qa = el?.dataset?.qa;
    if (!qa) return '';
    return qa.split('/').pop();
  }
}

customElements.define('mobile-menu', MobileMenu);
